import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import logger from 'Core-utils/logger';
import { SIGN_IN } from 'Core-utils/routes';
import { ToastsContext } from 'Rdx/contexts/ToastsContext';
import { useContext } from 'react';

export const useHmacValidation = (hash: string | undefined) => {
    const navigate = useNavigate();
    const { addToast } = useContext(ToastsContext);
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [hmacValidated, setHmacValidated] = useState(false);
    const hmacValidationStartedRef = useRef(false);

    useEffect(() => {
        if (!hash) {
            addToast({
                severity: 'error',
                body: 'Invalid training link. Please check your URL.',
            });
            navigate(SIGN_IN);
            return;
        }

        // Prevent duplicate validation calls (React StrictMode in dev)
        if (hmacValidationStartedRef.current) {
            return;
        }

        hmacValidationStartedRef.current = true;

        const validateHmacAndFetchVideo = async () => {
            try {
                const baseUrl = process.env.PLATFORM_API_URL || '';
                const response = await axios.get(`${baseUrl}/api/v1/trainings/${hash}`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.data?.success && response.data?.videoUrl) {
                    setVideoUrl(response.data.videoUrl);
                    setHmacValidated(true);
                    logger.log('HMAC validated, video URL fetched:', response.data.videoUrl);
                } else {
                    throw new Error('Invalid response from server');
                }
            } catch (error: any) {
                logger.error('Failed to validate HMAC:', error);
                addToast({
                    severity: 'error',
                    body: error?.response?.data?.error || 'Invalid or expired training link. Please contact your administrator.',
                });
                setTimeout(() => {
                    navigate(SIGN_IN);
                }, 2000);
            }
        };

        validateHmacAndFetchVideo();
    }, [hash, navigate, addToast]);

    return { videoUrl, hmacValidated };
};

